module.exports = __webpack_public_path__ + "static/media/rafy.c43c6175.jpg";